import { useAdminStore } from "@voix/store/adminStore";
import { $voixNuxtApi } from "@voix/voix-layer/composables/voixNuxtApi";
const copyElement = async (elementData) => {
  const adminStore = useAdminStore();
  adminStore.isLoading = true;
  const request = await $voixNuxtApi(
    `/api/admin/voix/element-copies`,
    {
      method: "POST",
      body: elementData
    }
  );
  adminStore.isLoading = false;
  return request;
};
const copyElements = async (elementData) => {
  const adminStore = useAdminStore();
  adminStore.isLoading = true;
  const request = await $voixNuxtApi(
    `/api/admin/voix/element-copies/bulk`,
    {
      method: "POST",
      body: elementData
    }
  );
  adminStore.isLoading = false;
  return request;
};
export { copyElement, copyElements };
